export default {
  work: {
    name: '',
    location: '',
    position: '',
    url: '',
    startDate: '',
    endDate: '',
    summary: '',
    highlights: [],
  },
  projects: {
    name: '',
    description: '',
    highlights: [],
    startDate: '',
    endDate: '',
    roles: [],
    url: '',
  },
  education: {
    institution: '',
    area: '',
    studyType: '',
    url: '',
    startDate: '',
    endDate: '',
    score: '',
    minors: [],
    courses: [],
  },
  volunteer: {
    organization: '',
    position: '',
    url: '',
    startDate: '',
    endDate: '',
    summary: '',
    highlights: [],
  },
  awards: {
    title: '',
    awarder: '',
    date: '',
    summary: '',
  },
  publications: {
    name: '',
    publisher: '',
    releaseDate: '',
    url: '',
    summary: '',
  },
  certificates: {
    name: '',
    issuer: '',
    date: '',
    url: '',
  },
  skills: {
    name: '',
    level: '',
    keywords: [],
  },
  categorizedSkills: {
    name: '',
    skills: [],
  },
  languages: {
    language: '',
    fluency: '',
  },
  interests: {
    name: '',
    keywords: [],
  },
  references: {
    name: '',
    reference: '',
  },
}
